import {createMultiStyleConfigHelpers} from '@chakra-ui/react'
import {remCalc} from '../../_utils'

const helpers = createMultiStyleConfigHelpers([
    'searchAndTitleStyles',
    'bannerLiveChatStyles',
    'categoriesCardStyles',
    'quickLinksStyles',
    'pageContainer',
    'articlesListStyles',
    'singleArticleStyles',
    'goBackButtonStyles',
])

const Faq = helpers.defineMultiStyleConfig({
    baseStyle: {
        pageContainer: {
            paddingX: {
                base: remCalc(16),
                md: remCalc(24),
                '2xl': remCalc(260),
            },
            gap: {base: remCalc(40), lg: remCalc(64)},
        },
        breadAndBannerContainer: {
            w: '100%',
            h: '100%',
            gap: remCalc(0),
        },
        breadcrumbContainer: {
            paddingY: remCalc(12),
            alignSelf: 'flex-start',
        },
        searchContainerGap: {
            w: '100%',
            alignItems: 'flex-start',
            gap: {base: remCalc(24), lg: remCalc(40)},
        },
        searchAndTitleStyles: {
            outerContainer: {
                w: '100%',
                alignItems: 'flex-start',
                p: {
                    base: [0, remCalc(16), remCalc(14), remCalc(16)],
                    lg: 0,
                },
                gap: {
                    base: remCalc(24),
                    lg: remCalc(40),
                },
                alignSelf: {
                    base: 'stretch',
                    lg: 'normal',
                },
            },
            midContainer: {
                alignItems: 'flex-start',
                paddingX: 0,
                alignSelf: {
                    base: 'stretch',
                    lg: 'normal',
                },
                borderBottom: remCalc(1),
                borderStyle: 'solid',
                borderColor: 'border.light',
            },
            innerContainer: {
                padding: `${remCalc(24)} 0`,
                alignItems: 'flex-start',
                gap: remCalc(24),
            },
            titleText: {
                color: 'text.default',
                textStyle: {
                    base: 'head-medium',
                    lg: 'head-xlarge',
                },
                fontWeight: 'medium',
                fontSize: {base: remCalc(28)},
            },
            subTitleText: {
                color: 'text.default',
                textStyle: {
                    base: 'head-small',
                    lg: 'head-medium',
                },
                fontWeight: 'medium',
                pt: {base: remCalc(24), lg: remCalc(40)},
            },
            searchContainer: {
                alignItems: {
                    base: 'center',
                    lg: 'flex-start',
                },
                gap: {
                    base: 0,
                    lg: remCalc(16),
                },
                marginTop: remCalc(28),
            },
            errorMessage: {
                alignSelf: 'flex-start',
                color: 'text.tertiary',
                textStyle: 'body-medium',
                fontWeight: 'normal',
            },
        },
        bannerFaqStyles: {
            bannerContainer: {
                w: '100%',
                padding: {base: remCalc(16), lg: remCalc(24)},
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                borderRadius: 'large.lg',
                flex: '1 0 0',
            },
            bannerGrid: {
                gap: {base: remCalc(24), lg: remCalc(40)},
                flexDirection: {base: 'column', lg: 'row'},
                flex: '1 0 0',
            },
            bannerContent: {
                flexDirection: 'column',
                gap: remCalc(16),
                textAlign: {base: 'center', lg: 'start'},
                alignSelf: 'center',
            },
            bannerIcon: {
                boxSize: {base: remCalc(140), lg: remCalc(200)},
                aspectRatio: '1 / 1',
                display: 'flex',
                justifyContent: 'center',
                alignSelf: 'center',
            },
            bannerHeading: {
                textStyle: 'head-medium',
                fontWeight: 'medium',
                color: 'text.default',
            },
            bannerBodycopy: {
                textStyle: 'body-medium',
                fontWeight: 'normal',
                color: 'text.default',
            },
        },
        bannerLiveChatStyles: {
            bannerContainer: {
                w: '100%',
                justifyContent: {
                    base: 'none',
                    lg: 'space-between',
                },
                alignItems: {
                    base: 'flex-start',
                    lg: 'center',
                },
                alignContent: {
                    base: 'flex-start',
                    lg: 'center',
                },
                rowGap: remCalc(22),
                gap: {
                    base: remCalc(22),
                    lg: 'none',
                },
                border: remCalc(1),
                borderStyle: 'solid',
                borderColor: 'border.light',
                borderRadius: 'large.lg',
            },
            bannerInnerContainer: {
                flexDir: {
                    base: 'column',
                    lg: 'row',
                },
                alignItems: 'center',
                justifyContent: 'center',
                gap: remCalc(22),
                padding: {
                    base: remCalc(22),
                    lg: remCalc(42),
                },
                flex: '1 0 0',
            },
            iconContainer: {
                w: {
                    base: 'iconsSize.large',
                    lg: 'iconsSize.xlarge',
                },
                h: {
                    base: 'iconsSize.large',
                    lg: 'iconsSize.xlarge',
                },
                justifyContent: 'center',
                alignItems: 'center',
            },
            adviceIcon: {
                w: '100%',
                h: '100%',
            },
            simpleText: {
                color: 'text.default',
                textStyle: 'body.medium',
                fontWeight: 'normal',
            },
            linkText: {
                color: 'text.tertiary',
                textDecorationLine: 'underline',
                textDecorationStyle: 'solid',
                textDecorationThickness: 'auto',
            },
        },
        categoriesCardStyles: {
            categoriesCardContainer: {
                w: '100%',
                h: 'auto',
                alignItems: 'flex-start',
                gap: {base: remCalc(40), lg: remCalc(80)},
            },
            categoriesTitle: {
                color: 'text.default',
                textStyle: {
                    base: 'head-xsmall',
                    lg: 'head-medium',
                },
                fontWeight: 'medium',
            },
        },
        quickLinkStyles: {
            outerContainer: {
                w: '100%',
                h: 'auto',
                gap: {
                    base: remCalc(32),
                    lg: remCalc(55),
                },
                paddingY: {base: remCalc(32), lg: remCalc(28)},
                borderTop: remCalc(1),
                borderStyle: 'solid',
                borderColor: 'border.light',
                marginBottom: {
                    base: remCalc(40),
                    lg: remCalc(80),
                },
            },
            titleText: {
                color: 'text.default',
                textStyle: 'head-small',
                fontWeight: 'medium',
            },
            flexContainer: {
                w: 'full',
                gap: {base: remCalc(32), lg: `${remCalc(61)} ${remCalc(24)}`},
                flexDirection: {base: 'column', md: 'row'},
                flexWrap: {base: 'none', md: 'wrap'},
                justifyContent: {base: 'flex-start', md: 'center'},
                alignItems: 'flex-start',
            },
            flexItem: {
                display: 'flex',
                flexDirection: 'row',
                gap: remCalc(16),
                alignItems: 'center',
            },
            iconWraper: {
                display: 'inline',
                boxSize: {
                    base: 'iconsSize.large',
                    lg: 'iconsSize.xlarge',
                },
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: {
                    base: 'null',
                    lg: 0,
                },
            },
            gridItemText: {
                color: 'text.default',
                textStyle: 'body-large',
                fontWeight: 'normal',
            },
        },
        articlesListStyles: {
            outerContainer: {
                w: '100%',
                h: 'auto',
                alignItems: 'flex-start',
                gap: remCalc(40),
            },
            middleContainer: {
                w: '100%',
                h: 'auto',
                alignItems: 'flex-start',
                gap: remCalc(40),
            },
            innerContaienr: {
                alignItems: 'flex-start',
                gap: remCalc(18),
                alignSelf: 'stretch',
            },
            listWrapper: {
                w: '100%',
                h: 'auto',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
            },
            articleWrapper: {
                alignItems: 'flex-start',
                alignSelf: 'stretch',
                w: '100%',
                h: 'auto',
            },
            articleInnerContainer: {
                w: '100%',
                h: 'auto',
                paddingY: remCalc(12),
                paddingX: 0,
                alignSelf: 'stretch',
                alignItems: 'center',
            },
            chevronIcon: {
                display: 'flex',
                w: 'iconsSize.medium',
                h: 'iconsSize.medium',
                justifyContent: 'center',
                alignItems: 'center',
                mr: remCalc(12),
            },
            articleLink: {
                color: 'text.secondary',
                textStyle: 'body-medium',
                fontWeight: 'normal',
            },
            toogleCtaContainer: {
                alignItems: {base: 'center', lg: 'flex-start'},
                width: '100%',
                gap: remCalc(36),
            },
            toogleCtaButton: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: remCalc(10),
            },
            toogleText: {
                color: 'text.default',
                textStyle: 'body-xsmall',
                fontWeight: 'bold',
                textDecorationLine: 'underline',
                textDecorationStyle: 'solid',
                textDecorationThickness: 'auto',
                textUnderlineOffset: 'auto',
            },
        },
        singleArticleStyles: {
            paragraphs: {
                color: 'text.secondary',
                textStyle: 'body-small',
                fontWeight: 'medium',
                h: 'auto',
                width: '100%',
            },
            listItems: {
                color: 'text.secondary',
            },
            strongText: {
                fontWeight: 'bold',
            },
        },
        goBackButtonStyles: {
            outerContainer: {
                w: '100%',
                h: 'auto',
                alignItems: 'flex-start',
                color: 'text.tertiary',
            },
            buttonWrapper: {
                display: 'flex',
                flexDir: 'row',
                alignItems: 'center',
                gap: remCalc(12),
                cursor: 'pointer',
                fontSize: 'head-xsmall',
            },
            iconWrapper: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                w: 'iconsSize.medium',
                h: 'iconsSize.medium',
            },
            goBackText: {
                fontSize: remCalc(20),
                lineHeight: remCalc(22),
                fontWeight: 'medium',
            },
        },
    },
})

export default Faq
